import React, { useRef, useState } from 'react';
import { View } from 'react-native';
import { multiOptionCardStyle } from '../style';
import { useTheme, Typography, Icons, ActivityIndicator } from '@hmsexp/component-library';
import ActionPopover from './ActionPopover';
import TabSwitcher from './TabSwitcher';
import GenericNoData from '../../NoData/GenricNoData';

const MultiFeatureCard = props => {
  const {
    title,
    subTitle,
    renderFooter,
    enableSwitchTab = false,
    enableActionBtn = false,
    style = {},
    renderContent,
    switchOptions = [],
    onActionButtonClick,
    loading,
    isNoData,
    actionMenu
  } = props;

  const defaultActionMenu = [
    {
      title: 'Export',
      icon: <Icons.UploadIcon />,
      items: [
        { label: 'PDF', id: 'pdf' },
        { label: 'Powerpoint', id: 'ppt' },
        { label: 'Image', id: 'img' },
        { label: 'Excel', id: 'xls' }
      ]
    }
  ];

  const actionMenuData = actionMenu?.length ? actionMenu : defaultActionMenu;

  const theme = useTheme();
  const styles = multiOptionCardStyle(theme);
  const childRef = useRef(null);

  const handleActionClick = e => {
    childRef.current?.actionButtonClick?.(e);
    onActionButtonClick?.(e);
  };

  const [activeSwitch, setActiveSwitch] = useState(switchOptions[0]);

  const renderChildren = () => {
    if (isNoData) {
      return <GenericNoData />
    }
    return <View style={style.childContainer}>
      {loading && <View style={styles.loadingOverlay}>
        <ActivityIndicator height={40} width={40} isDarkBg={false} />
      </View>}
      {renderContent && renderContent(activeSwitch, childRef)}</View>;
  };

  return (
    <View style={styles.chartCardMainContainer}>
      <View style={styles.chartCardHeaderContainer}>
        <View style={{ flex: 1, gap: 7 }}>
          <Typography textProps={{ numberOfLines: 1, ellipsizeMode: 'tail' }} variant='subtitle1' fontWeightType='bold'>
            {title}
          </Typography>
          <Typography
            color='primaryContentMedium'
            textProps={{ numberOfLines: 1, ellipsizeMode: 'tail' }}
            variant='body2'
            fontWeightType='regular'>
            {subTitle}
          </Typography>
        </View>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 20 }}>
          {enableSwitchTab && (
            <TabSwitcher onTabChange={setActiveSwitch} activeOption={activeSwitch} switchOptions={switchOptions} />
          )}
          {enableActionBtn && (
            <ActionPopover
              actionMenuData={actionMenuData}
              onItemClick={e => {
                handleActionClick(e);
              }}
            />
          )}
        </View>
      </View>

      {renderChildren()}
      <View style={style.footerContainer}>{renderFooter && renderFooter()}</View>
    </View>
  );
};
export default MultiFeatureCard;
